export const ChatSkeleton = () => (
  <div style={{ display: 'flex', flexDirection: 'column', height: '100dvh', background: '#fff' }}>
    {/* Header */}
    <div style={{
      height: 64, background: '#fff', borderBottom: '1px solid #f0f0f0',
      display: 'flex', alignItems: 'center', gap: 12, padding: '0 16px',
      position: 'fixed', top: 0, width: '100%', zIndex: 100, boxSizing: 'border-box'
    }}>
      <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#e8e8e8' }} className="sk" />
      <div style={{ flex: 1 }}>
        <div style={{ width: 130, height: 13, background: '#e8e8e8', borderRadius: 6, marginBottom: 7 }} className="sk" />
        <div style={{ width: 90, height: 10, background: '#e8e8e8', borderRadius: 6 }} className="sk" />
      </div>
    </div>

    {/* Messages area */}
    <div style={{ flex: 1, padding: '84px 16px 80px', display: 'flex', flexDirection: 'column', gap: 14 }}>
      {[
        { width: 180, align: 'flex-start' },
        { width: 220, align: 'flex-end' },
        { width: 150, align: 'flex-start' },
        { width: 260, align: 'flex-end' },
        { width: 190, align: 'flex-start' },
      ].map((item, i) => (
        <div key={i} style={{ display: 'flex', justifyContent: item.align }}>
          <div style={{
            width: item.width, height: 42,
            background: '#e8e8e8', borderRadius: 14
          }} className="sk" />
        </div>
      ))}
    </div>

    {/* Input */}
    <div style={{
      position: 'fixed', bottom: 0, width: '100%',
      height: 64, background: '#fff', borderTop: '1px solid #f0f0f0',
      display: 'flex', alignItems: 'center', padding: '0 16px',
      gap: 10, boxSizing: 'border-box'
    }}>
      <div style={{ flex: 1, height: 38, background: '#e8e8e8', borderRadius: 20 }} className="sk" />
      <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#e8e8e8' }} className="sk" />
    </div>

    <style>{`
      .sk {
        background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%);
        background-size: 200% 100%;
        animation: shimmer 1.4s infinite;
      }
      @keyframes shimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
    `}</style>
  </div>
);
